import Vue from 'vue'
import Router from 'vue-router'

import Navbar from './components/Navbar'
import Footer from './components/Footer'

import Landing from './components/views/Landing'
import Privacy from './components/views/Privacy'
import Terms from './components/views/Terms'

// base pages
import DownloadPage from './components/views/traffic/DownloadPage'
import DownloadPageAdjust from './components/views/traffic/DownloadPageAdjust'
import DownloadPageCustom from './components/views/traffic/DownloadPageCustom'
import DownloadPageNew from './components/views/traffic/DownloadPageNew'
import StorePage from './components/views/traffic/StorePage'
import StorePageImproved from './components/views/traffic/StorePageImproved'
import StorePageImprovedAdjust from './components/views/traffic/StorePageImprovedAdjust'

// redirect pages
import RedirectTenjin from './components/views/traffic/RedirectTenjin'
import RedirectAdjust from './components/views/traffic/RedirectAdjust'


Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Landing',
      components: { default: Landing },
      props: {
        default: { 
          // required
          siteId: "landing",
          icons: [require('@/assets/images/ddlogo.png'), require('@/assets/images/ddlogo.png')],
        }
      }
    },
    {
      path: '/cpmp_red',
      name: 'CPMP Redirect',
      components: { default: RedirectAdjust },
      props: {
        default: { 
          // required
          siteId: "cpmp_redirect",
          callbackUrls: ["https://app.adjust.com/fqn2yqt"],

          // pixels
          fbPixelId: "2561603140818002"
        }
      }
    },

    {
      path: '/cpmp_app',
      name: 'Color Pop Adjust',
      components: { default: DownloadPageAdjust },
      props: {
        default: { 
          // required
          appName: 'Color Pop', 
          callbackUrls: ["https://app.adjust.com/fqn2yqt"],
          siteId: "cpmp_app",
          icons: [require('@/assets/store_files/images/colorpop/icon.jpg'), require('@/assets/store_files/images/colorpop/icon.jpg')],

          // pixels
          fbPixelId: "2561603140818002",
        }
      }
    },
    {
      path: '/cpmp_app_3',
      name: 'Color Pop Adjust',
      components: { default: DownloadPageCustom },
      props: {
        default: { 
          // required
          appName: 'Color Pop', 
          callbackUrls: ["https://app.adjust.com/di5o2cz"],
          siteId: "cpmp_app_3",
          icons: [require('@/assets/store_files/images/colorpop/colorpoptitle.png'), require('@/assets/store_files/images/colorpop/colorpoptitle.png')],

          // pixels
          fbPixelId: "2561603140818002",
          snapPixelId: "2818ea93-c8ff-4aa7-b3b8-0beb024674a0",
        }
      }
    },

    {
      path: '/cpmp_store',
      name: 'Color Pop Desc',
      components: { default: StorePageImprovedAdjust },
      props: {
        default: { 
          // required
          appName: 'Color Pop', 
          callbackUrls: ["https://app.adjust.com/fqn2yqt"],
          siteId: "cpmp_store",
          icon: require('@/assets/store_files/images/colorpop/icon.jpg'),
          landing: require('@/assets/store_files/images/landing.jpg'),
          long1: require('@/assets/store_files/images/colorpop/p1.jpg'),
          long2: require('@/assets/store_files/images/colorpop/p2.jpg'),
          long3: require('@/assets/store_files/images/colorpop/p3.jpg'),
          long4: require('@/assets/store_files/images/colorpop/p4.jpg'),
          normal1: require('@/assets/store_files/images/colorpop/1.jpg'),
          normal2: require('@/assets/store_files/images/colorpop/2.jpg'),
          normal3: require('@/assets/store_files/images/colorpop/3.jpg'),
          normal4: require('@/assets/store_files/images/colorpop/4.jpg'),

          // pixels
          fbPixelId: "2561603140818002",

          //optionals
          appDescription: "Dylan Davis",
          developer: "Dylan Davis",
          score: "4.6",
          rank: "5",
          category: "Puzzle",
          age: "4+",
          rating: "1.6K",
          description: `Color Pop will keep you hooked for hours!<br/><br/>
          Pop similarly colored balls with a simple tap. When you pop enough balls at once and you will earn booster to help you!<br/>
          Easy to play, hard to master.<br/>
          Features amazing colorful gameplay.<br/>
          Build your newest addiction!`
        }
      }
    },
    {
        path: '/cpmp_store_1',
        name: 'Color Pop Desc 1',
        components: { default: StorePageImprovedAdjust },
        props: {
          default: { 
            // required
            appName: 'Color Pop', 
            callbackUrls: ["https://app.adjust.com/fqn2yqt"],
            siteId: "cpmp_store_1",
            icon: require('@/assets/store_files/images/colorpop/icon.jpg'),
            landing: require('@/assets/store_files/images/landing.jpg'),
            long1: require('@/assets/store_files/images/colorpop/p1.jpg'),
            long2: require('@/assets/store_files/images/colorpop/p2.jpg'),
            long3: require('@/assets/store_files/images/colorpop/p3.jpg'),
            long4: require('@/assets/store_files/images/colorpop/p4.jpg'),
            normal1: require('@/assets/store_files/images/colorpop/1.jpg'),
            normal2: require('@/assets/store_files/images/colorpop/2.jpg'),
            normal3: require('@/assets/store_files/images/colorpop/3.jpg'),
            normal4: require('@/assets/store_files/images/colorpop/4.jpg'),
  
            // pixels
            fbPixelId: "2561603140818002",
  
            //optionals
            appDescription: "Dylan Davis",
            developer: "Dylan Davis",
            score: "4.6",
            rank: "5",
            category: "Puzzle",
            age: "4+",
            rating: "1.6K",
            description: `WELCOME TO COLOR POP MATCHING PUZZLE!<br/>
            Be prepared to discover the fun world of puzzles. You will love to be in charge to make the right choices among countless possibilities and overcome the mental challenges. Want to know why you will love it?<br/><br/>
            SIMPLE YET CHALLENGING<br/>
            Match the colors as you progress through various challenging levels. Your talent in solving puzzles is key to pass levels. You will have to plan your moves and use boosters wisely along your way to become a Color Pop master.<br/><br/>
            UNIQUE GAMEPLAY<br/>
            Tap same colored balls to pop them and clear the way through winning rewards. Combine explosive boosters for huge blasts. Overcome rope obstacles that are keeping your balls from falling down to the next stage.<br/><br/>
            ENDLESS FUN<br/>
            You can play Color Pop whether you are at home or on the go. You will enjoy spending your hours on passing hundreds of levels and earning rewards from chests. Better you play, more rewards you get through your adventure.`
          }
        }
      },
      {
        path: '/cpmp_store_2',
        name: 'Color Pop Desc 2',
        components: { default: StorePageImprovedAdjust },
        props: {
          default: { 
            // required
            appName: 'Color Pop', 
            callbackUrls: ["https://app.adjust.com/fqn2yqt"],
            siteId: "cpmp_store_2",
            icon: require('@/assets/store_files/images/colorpop/icon.jpg'),
            landing: require('@/assets/store_files/images/landing.jpg'),
            long1: require('@/assets/store_files/images/colorpop/p1.jpg'),
            long2: require('@/assets/store_files/images/colorpop/p2.jpg'),
            long3: require('@/assets/store_files/images/colorpop/p3.jpg'),
            long4: require('@/assets/store_files/images/colorpop/p4.jpg'),
            normal1: require('@/assets/store_files/images/colorpop/1.jpg'),
            normal2: require('@/assets/store_files/images/colorpop/2.jpg'),
            normal3: require('@/assets/store_files/images/colorpop/3.jpg'),
            normal4: require('@/assets/store_files/images/colorpop/4.jpg'),
  
            // pixels
            fbPixelId: "2561603140818002",
  
            //optionals
            appDescription: "Dylan Davis",
            developer: "Dylan Davis",
            score: "4.6",
            rank: "5",
            category: "Puzzle",
            age: "4+",
            rating: "1.6K",
            description: `WELCOME TO THE ULTIMATE PUZZLE GAME WITH UNIQUE GAMEPLAY!<br/>
            Pop the balls of the same color and unleash special boosters to blast your way through the puzzles. Enter the ball pit and see if you can manage your way out of it with hundreds of puzzles.<br/>
            Are you ready for the challenge?<br/><br/>
            WHY YOU'LL LOVE COLOR POP<br/>
            • PLAY on the go or at home<br/>
            • ENDLESS fun with hundreds of levels<br/>
            • EARN rewards from chests while you are going through levels<br/>
            • ENJOY the simple and relaxing design<br/>
            • UNIQUE obstacles and experience every time<br/>
            • BLAST the balls with a single tap<br/>
            Join the adventure now!`
          }
        }
      },
      {
        path: '/cpmp_store_3',
        name: 'Color Pop Desc 3',
        components: { default: StorePageImprovedAdjust },
        props: {
          default: { 
            // required
            appName: 'Color Pop', 
            callbackUrls: ["https://app.adjust.com/fqn2yqt"],
            siteId: "cpmp_store_3",
            icon: require('@/assets/store_files/images/colorpop/icon.jpg'),
            landing: require('@/assets/store_files/images/landing.jpg'),
            long1: require('@/assets/store_files/images/colorpop/p1.jpg'),
            long2: require('@/assets/store_files/images/colorpop/p2.jpg'),
            long3: require('@/assets/store_files/images/colorpop/p3.jpg'),
            long4: require('@/assets/store_files/images/colorpop/p4.jpg'),
            normal1: require('@/assets/store_files/images/colorpop/1.jpg'),
            normal2: require('@/assets/store_files/images/colorpop/2.jpg'),
            normal3: require('@/assets/store_files/images/colorpop/3.jpg'),
            normal4: require('@/assets/store_files/images/colorpop/4.jpg'),
  
            // pixels
            fbPixelId: "2561603140818002",
  
            //optionals
            appDescription: "Dylan Davis",
            developer: "Dylan Davis",
            score: "4.6",
            rank: "5",
            category: "Puzzle",
            age: "4+",
            rating: "1.6K",
            description: `Color Pop is an exciting new match-3 game. Pop similarly colored balls with a simple tap. When you pop enough balls at once, you will earn boosters to help you! You can test your skills in this fun and challenging puzzle game. Specially crafted levels will keep you hooked for hours!<br/><br/>
            • Match and pop the colors<br/>
            • Solve endless, colorful and exciting puzzles<br/>
            • Complete hundreds of different levels<br/>
            • Open chests and unlock surprising gifts<br/>
            • Level up and win amazing rewards like boosters and infinite lives!<br/>
            • Use boosters if you need help!<br/>
            • New levels are added every week<br/>
            • Play now for free!<br/>`
          }
        }
      },
      {
        path: '/mdhd_app',
        name: 'Mergedom: Home Design',
        components: { default: DownloadPageNew },
        props: {
          default: { 
            // required
            appName: 'Mergedom: Home Design', 
            callbackUrls: ["https://track.tenjin.io/v0/click/bzrIlN5BWwLXxhxTgiWnjU"],
            siteId: "mdhd_app",
            icons: [require('@/assets/images/mdhd_icon.png'), require('@/assets/images/mdhd_icon.png')],

            // pixels
            fbPixelId: "276635080580737",
          }
        }
      }







  ]
})



// WEBPACK FOOTER //
// ./src/router.js